import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Endpoints } from 'src/environments/endpoints';
import { CallBackEmptyConst } from '../constants/const';
import { SpinnerNames } from '../constants/spinners';
import {
  CatalogFieldResponse,
  CatalogFiscalRegimeResponseClass,
  GeneralParamsSearch,
  ICatalgosDermaRes,
  ICatalogsMissingProRes,
  ICatalogsResponse,
  IGeneralFiltersResponse,
  IListSearchProductType,
  InvalidBusinessNameResponseClass,
  PowerBiReportResponse,
  TInvalidBusinessNameItem
} from '../model/http/catalogs';
import { ConsumeService } from './consume.service';
import { PaymentTimeResponse } from '../model/http/payments.time.model';
import { PaymentTimesMock } from 'src/mocks/paymentTimes.mock';

@Injectable({
  providedIn: 'root',
})
export class CatalogsService {
  invalidBusinessName: Array<TInvalidBusinessNameItem> = [];
  constructor(private consumeService: ConsumeService) {}

  getCatalogs(cardCode: string): Observable<ICatalogsResponse> {
    return this.consumeService.httpGet<ICatalogsResponse>(
      `${Endpoints.catalogs.getContainercustomlabels}${cardCode}`
    );
  }
  getCatalogDerma(): Observable<ICatalgosDermaRes> {
    return this.consumeService.httpGet<ICatalgosDermaRes>(
      Endpoints.catalogs.listDerma
    );
  }
  getMissingProductCata(): Observable<ICatalogsMissingProRes> {
    return this.consumeService.httpGet(Endpoints.catalogs.missingProducts);
  }
  getDinamicParams(): Observable<CatalogFieldResponse> {
    return this.consumeService.httpGet(Endpoints.oxxoPaymentLimit);
  }

  fiscalRegime = (): Observable<CatalogFiscalRegimeResponseClass> => {
    return this.consumeService.httpGet(Endpoints.catalogs.taxRegimen);
  }

  loadInvalidBusinessName = (
    okLoad: CallableFunction = CallBackEmptyConst
  ): void => {
    this.consumeService
      .httpGet<InvalidBusinessNameResponseClass>(
        Endpoints.catalogs.invalidBusinessName
      )
      .subscribe(({ response }) => {
        okLoad();
        this.invalidBusinessName = response;
      });
  }

  existInvalidBusiness = (businessName?: string): boolean => {
    if (!businessName) {
      return false;
    }
    const businessNameLower = businessName.toLowerCase();
    return (
      this.invalidBusinessName.find(({ value }) => {
        const valueLower = value.toLocaleLowerCase();
        const compare = businessNameLower.trim().substr(valueLower.length * -1);
        return compare.includes(valueLower);
      }) !== undefined
    );
  }

  getMinPiecesQuantity(): Observable<CatalogFieldResponse> {
    return this.consumeService.httpGet(Endpoints.minPiecesQuantity);
  }

  getGeneralFilters(params: string): Observable<IGeneralFiltersResponse> {
    return this.consumeService.httpGet(`${Endpoints.filters.getGeneralFilters}${params}`, null, null, SpinnerNames.generalSearch);
  }

  getSearchProductCatalog(params: GeneralParamsSearch, spinnerName: SpinnerNames): Observable<IListSearchProductType> {
    return this.consumeService.httpPost<IListSearchProductType>(
      Endpoints.catalogsProduct.generalSearch,
      params,
      null,
      false,
      spinnerName
    );
  }

  getPaymentTimeResponse(): Observable<PaymentTimeResponse> {
    return this.consumeService.httpGet<PaymentTimeResponse>(Endpoints.getPaymentTimes.get);
  }

  getReportToken(reportName: string): Observable<PowerBiReportResponse> {
    return this.consumeService.httpGet<PowerBiReportResponse>(`${Endpoints.catalogs.powerBiReportToken}/${reportName}`);
  }
}
